import { createApp } from "./main";

const { app } = createApp();

app.$mount("#basic-auth");
